import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import Logo from './Logo';

const Footer = () => {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer className="bg-white text-gray-700 border-t border-gray-200 mt-20">
      {/* Main content sections */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand section */}
          <div className="space-y-4 text-center md:text-left">
            <Link onClick={handleScrollToTop} to="/" className="inline-block group">
              <Logo className="h-[48px] sm:h-[54px] w-auto mx-auto md:mx-0 transition-transform duration-300 group-hover:scale-[1.02]" />
            </Link>
            <p className="text-gray-600 text-sm leading-relaxed">
              Empowering global businesses with autonomous AI workflows, conversational voice agents, intelligent chatbots, and high-performance software engineering.
            </p>

            {/* Enterprise Engineering & Security Guarantee */}
            <div className="inline-flex items-center gap-2.5 bg-gray-50 p-3 rounded-xl border border-gray-200 text-left">
              <div className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0">
                <span className="font-bold text-sm">✓</span>
              </div>
              <div>
                <p className="text-[11px] text-gray-900 font-bold leading-tight">
                  100% IP Ownership
                </p>
                <p className="text-[10px] text-gray-500 leading-tight mt-0.5">
                  Full Codebase &amp; NDA Protected
                </p>
              </div>
            </div>
          </div>

          {/* Company section */}
          <div className="text-center md:text-left">
            <h3 className="font-bold text-gray-900 text-base uppercase tracking-wider mb-4 border-b-2 border-red-500 pb-1 inline-block">
              Company
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link onClick={handleScrollToTop} to="/About" className="hover:text-red-600 transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link onClick={handleScrollToTop} to="/Portfolio" className="hover:text-red-600 transition">
                  Portfolio & Case Studies
                </Link>
              </li>
              <li>
                <Link onClick={handleScrollToTop} to="/Why-us" className="hover:text-red-600 transition">
                  Why Choose Us
                </Link>
              </li>
              <li>
                <Link onClick={handleScrollToTop} to="/Contact" className="hover:text-red-600 transition">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link onClick={handleScrollToTop} to="/Privacy" className="hover:text-red-600 transition">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Core Services */}
          <div className="text-center md:text-left">
            <h3 className="font-bold text-gray-900 text-base uppercase tracking-wider mb-4 border-b-2 border-red-500 pb-1 inline-block">
              Core Services
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link onClick={handleScrollToTop} to="/Services" className="hover:text-red-600 transition">
                  Shopify & Headless E-Commerce
                </Link>
              </li>
              <li>
                <Link onClick={handleScrollToTop} to="/Services" className="hover:text-red-600 transition">
                  Cross-Platform Mobile Apps (Flutter)
                </Link>
              </li>
              <li>
                <Link onClick={handleScrollToTop} to="/Services" className="hover:text-red-600 transition">
                  Custom SaaS Platforms & MVPs
                </Link>
              </li>
              <li>
                <Link onClick={handleScrollToTop} to="/Services" className="hover:text-red-600 transition">
                  Backend APIs & Cloud DevOps
                </Link>
              </li>
              <li>
                <Link onClick={handleScrollToTop} to="/Services" className="hover:text-red-600 transition">
                  AI Workflows & Voice Telephony
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact section */}
          <div className="text-center md:text-left space-y-3">
            <h3 className="font-bold text-gray-900 text-base uppercase tracking-wider mb-4 border-b-2 border-red-500 pb-1 inline-block">
              Get In Touch
            </h3>
            
            {/* Office Locations */}
            <p className="flex items-center justify-center md:justify-start text-sm text-gray-600 gap-2.5">
              <FaMapMarkerAlt className="text-red-600 shrink-0" aria-hidden="true" />
              <span>128-B Spring Garden, NY, USA</span>
            </p>
            <p className="flex items-center justify-center md:justify-start text-sm text-gray-600 gap-2.5">
              <FaMapMarkerAlt className="text-red-600 shrink-0" aria-hidden="true" />
              <span>Islamabad, Pakistan</span>
            </p>

            {/* Email */}
            <p className="flex items-center justify-center md:justify-start text-sm text-gray-600 gap-2.5">
              <FaEnvelope className="text-red-600 shrink-0" aria-hidden="true" />
              <a href="mailto:contact@corespectators.com" className="hover:text-red-600 transition">
                contact@corespectators.com
              </a>
            </p>

            {/* Phone Numbers */}
            <p className="flex items-center justify-center md:justify-start text-sm text-gray-700 gap-2.5">
              <FaPhoneAlt className="text-red-600 shrink-0" aria-hidden="true" />
              <a href="tel:+13323788142" className="hover:text-red-600 transition">
                +1-332-378-8142 <span className="text-xs text-gray-600 font-semibold">(US)</span>
              </a>
            </p>
            <p className="flex items-center justify-center md:justify-start text-sm text-gray-700 gap-2.5">
              <FaPhoneAlt className="text-red-600 shrink-0" aria-hidden="true" />
              <a href="tel:+923335136060" className="hover:text-red-600 transition">
                +92 333 5136060 <span className="text-xs text-gray-600 font-semibold">(PK)</span>
              </a>
            </p>

            {/* Hours */}
            <p className="flex items-center justify-center md:justify-start text-sm text-gray-700 gap-2.5">
              <FaClock className="text-red-600 shrink-0" aria-hidden="true" />
              <span>Open: 24/7 AI &amp; Engineering Support</span>
            </p>
          </div>
        </div>
      </div>

      {/* Bottom copyright section */}
      <div className="border-t border-gray-100 py-6 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 text-center text-xs text-gray-600 space-y-2">
          <p>
            &copy; {new Date().getFullYear()} Core Spectators. All rights reserved. Pioneering Shopify Stores, Mobile Apps, SaaS MVPs &amp; AI Automations.
          </p>
          <p className="text-[12px] text-gray-600 font-medium">
            <span>Agentic Web Discovery: </span>
            <a href="/llms.txt" target="_blank" rel="noopener noreferrer" className="hover:text-red-600 underline font-semibold">llms.txt</a>
            <span className="mx-1.5">•</span>
            <a href="/ai-catalog.json" target="_blank" rel="noopener noreferrer" className="hover:text-red-600 underline font-semibold">ai-catalog.json (ARD)</a>
            <span className="mx-1.5">•</span>
            <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer" className="hover:text-red-600 underline font-semibold">Sitemap</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
